class Throttler {
  public static DELAY_IN_SECONDS = 25
  private timeoutId: ReturnType<typeof setTimeout> | null = null
  private delayInSeconds: number
  private afterCallback: (instance: Throttler) => void
  private beforeCallback: () => void
  private lastResult: any
  private lastError: any
  private callback: () => any

  constructor() {
    this.delayInSeconds = Throttler.DELAY_IN_SECONDS
  }

  public forCallback(callback: () => any) {
    this.callback = callback

    return this
  }

  public withDelayInSeconds(delayInSeconds: number) {
    this.delayInSeconds = delayInSeconds
    return this
  }

  public execute(): Promise<any | null> {
    if (this.timeoutId !== null) {
      return Promise.resolve(null)
    }

    this.timeoutId = setTimeout(() => {
      this.timeoutId = null
    }, this.delayInSeconds * 1000)

    return this.executeCallback()
  }

  public cancel() {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }

    return this
  }

  public before(callback: () => void) {
    this.beforeCallback = callback

    return this
  }

  public after(callback: (instance: Throttler) => void) {
    this.afterCallback = callback

    return this
  }

  private executeCallback() {
    if (this.beforeCallback) {
      this.beforeCallback()
    }

    return Promise.resolve(this.callback())
      .then((result) => {
        this.lastResult = result
        return result
      })
      .catch((error) => {
        this.lastError = error
        return error
      })
      .finally(() => {
        if (this.afterCallback) {
          this.afterCallback(this)
        }
      })
  }
}

export default Throttler
